export const isMobileDevice = (): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }

  // Check if it's a mobile device based on user agent
  const userAgent =
    navigator.userAgent ||
    navigator.vendor ||
    (window as unknown as { opera?: string }).opera ||
    '';

  // Check for mobile devices
  const mobileRegex =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;

  // Also check screen width as a fallback
  const isMobileScreen = window.innerWidth <= 768;

  // Check if it has touch support (most mobile devices do)
  const hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

  return mobileRegex.test(userAgent) || (isMobileScreen && hasTouch);
};

export const isDesktopDevice = (): boolean => {
  return !isMobileDevice();
};

// Hook version for React components
import { useEffect, useState } from 'react';

export const useDeviceDetection = () => {
  const [isMobile, setIsMobile] = useState(() => isMobileDevice());

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(isMobileDevice());
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return {
    isMobile,
    isDesktop: !isMobile,
  };
};
